import React, { useEffect, useReducer, useContext } from "react"
import { useHistory, useParams } from 'react-router-dom'
import axios from "axios"
import { CircularProgress } from '@material-ui/core'

import AuthContext from "../../../context/auth-context"
import { dataFetchReducer } from "../../Utils/requestUtils"
import { getProperMetadata } from "../utils/utils"
import ClientProfile from "./ClientProfile/ClientProfile"
import Observation from "./Observation/Observation"
import ErrorBoundary from "../../Utils/ErrorBoundary"
import RGOCRCard from "./Cards/RGOCRCard/RGOCRCard"
import CNHOCRCard from "./Cards/CNHOCRCard/CNHOCRCard"
import OthersCard from "./Cards/OthersCard/OthersCard"
import PassportCard from "./Cards/PassportCard/PassportCard"
import NationalRegistryOfForeignersCard from "./Cards/NationalRegistryOfForeignersCard/NationalRegistryOfForeignersCard"
import CinDigitalCard from "./Cards/CinDigitalCard/CinDigitalCard"

function FaceDatabaseValidation(props) {
    const history = useHistory()
    const user_data = useContext(AuthContext).user_data

    if (!user_data.roles.includes("read_face_database_validations")) {
        history.push("")
    }

    const { event_key } = useParams()

    const [eventState, dispatchEventState] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    useEffect(() => {
        dispatchEventState({ type: "data_fetch_init" })
        const timer = setTimeout(() => {
            axios.get('/dash/account_event/face_database_validation/' + event_key).then(response => {
                dispatchEventState({ type: "data_fetch_success", payload: response.data })
            }).catch(error => {
                if ((error.response || {}).status === 403) dispatchEventState({ type: "data_fetch_failure_403" })
                else if ((error.response || {}).status === 404) dispatchEventState({ type: "data_fetch_failure_404" })
                else dispatchEventState({ type: "data_fetch_failure" })
            })
        }, 500)
        return () => clearTimeout(timer)
    }, [event_key])

    if (eventState.fetchedData) {
        const event = eventState.fetchedData
        const decision_metadata = getProperMetadata(event.analysis_status_events)
        const docs = event?.event_data?.documents || {}

        const hasDocs = docs.rg || docs.cnh || docs.others || docs.passport || docs.national_registry_of_foreigners || docs.cin_digital

        return (
            <div style={{ display: "flex", margin: "10px 0px" }}>
                <div className="analysisCardContainer" style={{ flexGrow: "1", display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "stretch", gap: "0" }}>
                        <div style={{ flex: hasDocs ? "0 0 38%" : "1", minWidth: 0, display: "flex", flexDirection: "column" }}>
                            <ErrorBoundary>
                                <ClientProfile event={event} />
                            </ErrorBoundary>
                        </div>
                        {hasDocs &&
                            <div style={{ flex: "1", minWidth: 0, display: "flex", flexDirection: "column" }}>
                                {docs.rg && <ErrorBoundary><RGOCRCard rg={docs.rg} decision_metadata={decision_metadata} /></ErrorBoundary>}
                                {docs.cnh && <ErrorBoundary><CNHOCRCard cnh={docs.cnh} decision_metadata={decision_metadata} /></ErrorBoundary>}
                                {docs.others && <ErrorBoundary><OthersCard others={docs.others} /></ErrorBoundary>}
                                {docs.passport && <ErrorBoundary><PassportCard passport={docs.passport} /></ErrorBoundary>}
                                {docs.national_registry_of_foreigners && <ErrorBoundary><NationalRegistryOfForeignersCard national_registry_of_foreigners={docs.national_registry_of_foreigners} /></ErrorBoundary>}
                                {docs.cin_digital && <ErrorBoundary><CinDigitalCard cin_digital={docs.cin_digital} /></ErrorBoundary>}
                            </div>
                        }
                    </div>
                    <ErrorBoundary>
                        <Observation event={event} event_key={event_key} />
                    </ErrorBoundary>
                </div>
            </div>
        )
    } else if (eventState.isLoading) {
        return (
            <div style={{ width: "auto" }}>
                <div className='circularProgressCenter'>
                    <CircularProgress />
                </div>
            </div>
        )
    } else if (eventState.isError) {
        return (
            <div style={{ height: "80vh", display: "flex" }}>
                <p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
                    {eventState.errorMessage}
                </p>
            </div>
        )
    }

    return (
        <div className="analysisCardContainer" style={{ flexGrow: "1", display: "flex", flexDirection: "column" }}>
            Erro ao buscar informações
        </div>
    )
}

export default FaceDatabaseValidation
